module.exports = __webpack_public_path__ + "static/media/polar_bear_tile.31ce9c8c.png";